<template>
    <div>
        <div class="board_container">
            <BoardCategory :boardName="name[0]" :lists="backlogLists" @updateTask="reload"></BoardCategory>
            <BoardCategory :boardName="name[1]" :lists="todoLists" @updateTask="reload"></BoardCategory>
            <BoardCategory :boardName="name[2]" :lists="doneLists" @updateTask="reload"></BoardCategory>     
            <BoardCategory :boardName="name[3]" :lists="completeLists" @updateTask="reload"></BoardCategory>
        </div>
    </div>
</template>

<script>
import BoardCategory from './BoardCategory'
export default {
    name: "Board",
    data() {
        return {
            name: ['Backlog','Todo','Done','Complete']
        }
    },
    props: {
        backlogLists: Array,
        todoLists: Array,
        doneLists: Array,
        completeLists: Array
    },
    components: {
        BoardCategory
    },
    methods: {
        reload() {
            this.$emit('updateTask')
            console.log('reload di board')
        }
    },
}
</script>